export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_16.8d5260b4.jpg";